import dynamic from 'next/dynamic';

import Header from './Header';
import IconSort from './Header/IconSort';
import List from './List';
import Root from './Root';
import Section from './Section';

const Comments = {
  Header,
  IconSort,
  List,
  ReadOnlyAlert: dynamic(() => import('./ReadOnlyAlert')),
  Root,
  Section,
  TextEditor: dynamic(() => import('./TextEditor')),
  QuickComments: dynamic(() => import('./TextEditor/QuickComments')),
};

export default Comments;
